import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextInput, Paper, Title, Text, Container, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import AuthLogo from '@components/auth-logo';
import { confirmSignUp } from '@services/authentication';
import AuthModal from '@components/auth-modal';
import classes from './auth-common.module.css';

function Confirmation() {
  const location = useLocation();
  const [opened, { open, close }] = useDisclosure(false);
  const stateUsername = (location.state as { username?: string } | null)?.username || '';
  const queryParams = new URLSearchParams(location.search);
  const queryUsername = queryParams.get('login_name') || '';
  const initialUsername = stateUsername || queryUsername || '';
  const [username, setUsername] = useState<string>(initialUsername);
  const [code, setCode] = useState(queryParams.get('code') || '');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setError('');

    try {
      await confirmSignUp(username, code);
      open();
    } catch (err) {
      setError((err as Error)?.message || 'An error occurred');
    }
  };

  return (
    <Container size={420} my={40}>
      <AuthLogo />

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <Title ta="center" className={classes.title}>
          User Confirmation
        </Title>
        <TextInput
          label="Email"
          placeholder="user@govoylogic.com"
          required
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <TextInput
          label="Confirmation Code"
          placeholder="Confirmation Code"
          required
          mt="md"
          onChange={(e) => setCode(e.target.value)}
          value={code}
        />
        <Button
          fullWidth
          mt="xl"
          onClick={(event) => {
            handleClick(event).catch((e) => {
              console.error('Error in handleClick:', e);
            });
          }}
        >
          Confirm Account
        </Button>
        <Button variant="light" fullWidth mt="xl" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        {error && (
          <Text c="red" pt={20}>
            {error}
          </Text>
        )}
      </Paper>
      <AuthModal
        opened={opened}
        close={close}
        navTo="/login"
        state={{ username }}
        title="Confirmation successful!"
        message="You can now login with your credentials"
      />
    </Container>
  );
}

export default Confirmation;
